module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/payment/visa-b3bb5afd73b862195d1dfedb9e32663d.svg";